import { render } from "./UserRegistration.vue?vue&type=template&id=297673fb&scoped=true"
import script from "./UserRegistration.vue?vue&type=script&lang=js"
export * from "./UserRegistration.vue?vue&type=script&lang=js"

import "./UserRegistration.vue?vue&type=style&index=0&id=297673fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297673fb"]])

export default __exports__